import { TextBox } from 'devextreme-react';

import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, Collapse, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Breadcrumb from '../../components/common/breadcrumb';
import api from '../../services/api-configuration-v3';

const PlakaIleGrupajSorgulama = () => {
    // State tanımlamaları
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);
    const [plateNumber, setPlateNumber] = useState('');
    const [processingChassis, setProcessingChassis] = useState(null);
    const [deliveryModalOpen, setDeliveryModalOpen] = useState(false);
    const [selectedChassis, setSelectedChassis] = useState(null);
    const [selectedGroupageNo, setSelectedGroupageNo] = useState(null);
    const [deliveryImage, setDeliveryImage] = useState(null);
    const [deliveryImageBase64, setDeliveryImageBase64] = useState(null);
    const [isFirstDelivery, setIsFirstDelivery] = useState(false);
    const [openCollapses, setOpenCollapses] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const fileInputRef = useRef(null);

    const getUserId = () => {
        return parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));
    };
    useEffect(() => {
        setTimeout(() => {
            if (document.querySelector(".page-main-header")) document.querySelector(".page-main-header").classList.add('open');
            if (document.querySelector(".page-sidebar")) document.querySelector(".page-sidebar").classList.add('open');
        }, 500);

    }, []);

    // Veri çekme fonksiyonu
    const fetchData = async (resetCollapses = false) => {
        try {
            setLoading(true);
            const body = {
                employee_id: getUserId(),
                ...(plateNumber.trim() && { plate_number: plateNumber.trim() })
            };

            const response = await api.post('/getAllGroupagesForAgacliByPlate', body);

            if (response.data && Array.isArray(response.data)) {
                const formattedData = response.data.map(item => ({
                    grupajNo: item.groupage_no || '',
                    plaka: item.plate_number || '',
                    sofor: item.driver_name || '',
                    aracSayisi: item.vehicle_count || 0,
                    kapiCikisSayisi: item.door_exit_count || 0,
                    fromLocation: item.from_location || '',
                    toLocation: item.to_location || '',
                    shippingDate: item.shipping_date || null,
                    shippingType: item.shipping_type || '',
                    status: item.status || null,
                    vehicleDetails: (item.vehicle_details || []).map(vehicle => ({
                        chassisNo: vehicle.chassis_no || '',
                        deliveryDate: vehicle.delivery_date || null,
                        doorExitDate: vehicle.door_exit_date || null
                    }))
                }));

                setDataSource(formattedData);
                // Sadece yeni arama yapıldığında collapse'ları sıfırla
                if (resetCollapses) {
                    setOpenCollapses({});
                    setCurrentPage(1); // Yeni arama yapıldığında ilk sayfaya dön
                }
            } else {
                setDataSource([]);
            }
        } catch (error) {
            console.error('Error fetching groupages:', error);
            toast.error(error.response?.data?.error || error.message || "Grupaj bilgileri getirilirken hata oluştu");
            setDataSource([]);
        } finally {
            setLoading(false);
        }
    };

    // Enter tuşu ile arama
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            fetchData(true); // Yeni arama, collapse'ları sıfırla
        }
    };

    // Collapse toggle - Accordion (tek collapse açık)
    const toggleCollapse = (grupajNo) => {
        setOpenCollapses(prev => {
            const isCurrentlyOpen = prev[grupajNo];
            // Eğer tıklanan zaten açıksa kapat, değilse sadece bunu aç (diğerlerini kapat)
            if (isCurrentlyOpen) {
                return { ...prev, [grupajNo]: false };
            } else {
                return { [grupajNo]: true };
            }
        });
    };

    // Kapı çıkış API fonksiyonu (şase bazlı)
    const handleDoorExit = async (groupageNo, chassisNo) => {
        if (!groupageNo || !chassisNo) {
            toast.error('Grupaj numarası veya şase numarası bulunamadı');
            return;
        }

        try {
            setProcessingChassis(chassisNo);

            const userId = getUserId().toString();
            const exitDate = moment().format('YYYY-MM-DD HH:mm:ss');

            const body = {
                grupaj_no: groupageNo,
                chassis_no: chassisNo,
                user_id: userId,
                kapi_cikis: exitDate
            };

            const response = await api.post('/processDoorExitOrDelivery', body);

            // Results array'inde hata kontrolü
            const hasError = response.data?.results?.some(result => result.error) || response.data?.stats?.failed > 0;

            if (response.data?.success && !hasError) {
                toast.success('Kapı çıkış işlemi başarılı');
                fetchData(false); // Verileri yenile, collapse'ları koru
            } else {
                // Results içindeki hata mesajını bul
                const errorResult = response.data?.results?.find(result => result.error);
                const errorMessage = errorResult?.error || response.data?.error || 'Kapı çıkış işlemi başarısız';
                toast.error(errorMessage);
            }
        } catch (error) {
            console.error('Kapı çıkış hatası:', error);
            toast.error(error.response?.data?.error || error.message || 'Kapı çıkış işlemi sırasında hata oluştu');
        } finally {
            setProcessingChassis(null);
        }
    };

    // Resim seçme, küçültme ve base64'e çevirme
    const handleImageSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.type.startsWith('image/')) {
            toast.error('Lütfen bir resim dosyası seçin');
            return;
        }

        if (file.size > 5 * 1024 * 1024) { // 5MB limit
            toast.error('Resim boyutu 5MB\'dan küçük olmalıdır');
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            const originalBase64 = reader.result;
            const img = new Image();

            img.onload = () => {
                // Optimize edilmiş küçültme ayarları (413 hatasını önlemek için)
                const MAX_WIDTH = 900; // Biraz daha küçük boyut
                const MAX_HEIGHT = 900; // Biraz daha küçük boyut
                const INITIAL_QUALITY = 0.8; // Daha yüksek kalite (yazıların okunabilirliği için)
                const MAX_BASE64_SIZE_KB = 300; // Maksimum 300KB base64 (yaklaşık 225KB gerçek boyut)

                // İteratif küçültme fonksiyonu
                const compressImage = (targetWidth, targetHeight, quality) => {
                    const canvas = document.createElement('canvas');
                    canvas.width = targetWidth;
                    canvas.height = targetHeight;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
                    return canvas.toDataURL('image/jpeg', quality);
                };

                let width = img.width;
                let height = img.height;
                let quality = INITIAL_QUALITY;

                // İlk küçültme: Boyut kontrolü
                if (width > MAX_WIDTH || height > MAX_HEIGHT) {
                    const ratio = Math.min(MAX_WIDTH / width, MAX_HEIGHT / height);
                    width = Math.round(width * ratio);
                    height = Math.round(height * ratio);
                }

                // İlk base64 oluşturma
                let finalBase64 = compressImage(width, height, quality);
                let base64Only = finalBase64.includes(',') ? finalBase64.split(',')[1] : finalBase64;
                let base64SizeKB = (base64Only.length * 3) / 4 / 1024;

                // Eğer hala çok büyükse, iteratif olarak küçült
                let attempts = 0;
                const maxAttempts = 5;
                while (base64SizeKB > MAX_BASE64_SIZE_KB && attempts < maxAttempts) {
                    attempts++;

                    if (quality > 0.55) {
                        // Önce kaliteyi düşür (minimum %55'te tut)
                        quality = Math.max(0.55, quality - 0.1);
                    } else if (width > 650 || height > 650) {
                        // Sonra boyutu daha da küçült
                        width = Math.round(width * 0.85);
                        height = Math.round(height * 0.85);
                    } else {
                        // Son çare: hem boyut hem kalite (minimum %50)
                        width = Math.round(width * 0.9);
                        height = Math.round(height * 0.9);
                        quality = Math.max(0.5, quality - 0.05);
                    }

                    finalBase64 = compressImage(width, height, quality);
                    base64Only = finalBase64.includes(',') ? finalBase64.split(',')[1] : finalBase64;
                    base64SizeKB = (base64Only.length * 3) / 4 / 1024;
                }

                // Final base64'i set et
                setDeliveryImageBase64(finalBase64);

                // Base64 string uzunluğunu console'a yazdır
                const finalBase64Only = finalBase64.includes(',') ? finalBase64.split(',')[1] : finalBase64;
                const finalBase64SizeKB = (finalBase64Only.length * 3) / 4 / 1024;
                const finalBase64SizeMB = finalBase64SizeKB / 1024;
                // Blob oluştur ve dosyayı güncelle
                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob((blob) => {
                    const resizedFile = new File([blob], file.name, { type: 'image/jpeg' });
                    setDeliveryImage(resizedFile);
                }, 'image/jpeg', quality);
            };

            img.onerror = () => {
                toast.error('Resim yüklenirken hata oluştu');
            };

            img.src = originalBase64;
        };

        reader.onerror = () => {
            toast.error('Resim okunurken hata oluştu');
        };

        reader.readAsDataURL(file);
    };

    // Teslim API fonksiyonu (şase bazlı)
    const handleDelivery = async () => {
        if (!selectedChassis || !selectedGroupageNo) {
            toast.error('Şase veya grupaj seçilmedi');
            return;
        }

        // Her teslimde resim zorunlu
        if (!deliveryImageBase64) {
            toast.error('Teslim için resim yüklemek zorunludur');
            return;
        }

        try {
            setProcessingChassis(selectedChassis);

            const userId = getUserId().toString();
            const formattedDate = moment().format('YYYY-MM-DD HH:mm:ss');

            // Base64 string'inden Data URL prefix'ini kaldır (sadece Base64 kısmını al)
            const base64Only = deliveryImageBase64?.includes(',')
                ? deliveryImageBase64.split(',')[1]
                : deliveryImageBase64;

            const body = {
                grupaj_no: selectedGroupageNo,
                chassis_no: selectedChassis,
                user_id: userId,
                teslim_tarihi: formattedDate,
                ...(base64Only && { image: base64Only })
            };

            const response = await api.post('/processDoorExitOrDelivery', body);

            // Results array'inde hata kontrolü
            const hasError = response.data?.results?.some(result => result.error) || response.data?.stats?.failed > 0;

            if (response.data?.success && !hasError) {
                toast.success('Teslim işlemi başarılı');
                setDeliveryModalOpen(false);
                setSelectedChassis(null);
                setSelectedGroupageNo(null);
                setDeliveryImage(null);
                setDeliveryImageBase64(null);
                setIsFirstDelivery(false);
                if (fileInputRef.current) fileInputRef.current.value = '';
                fetchData(false); // Verileri yenile, collapse'ları koru
            } else {
                // Results içindeki hata mesajını bul
                const errorResult = response.data?.results?.find(result => result.error);
                const errorMessage = errorResult?.error || response.data?.error || 'Teslim işlemi başarısız';
                toast.error(errorMessage);
            }
        } catch (error) {
            console.error('Teslim hatası:', error);
            toast.error(error.response?.data?.error || error.message || 'Teslim işlemi sırasında hata oluştu');
        } finally {
            setProcessingChassis(null);
        }
    };

    return (
        <>
            <Breadcrumb current="Grupaj Sorgulama" />
            <div className="p-2 bg-light min-vh-100">
                <Card className="mb-0 border shadow-sm">
                    <CardBody className="p-3">
                        {/* Sade Filtre */}
                        <div
                            style={{
                                display: 'flex',
                                gap: '4px',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                marginBottom: '16px'
                            }}
                        >
                            <TextBox
                                id="plateNumber"
                                placeholder="Plaka ara..."
                                value={plateNumber}
                                onValueChange={(value) => {
                                    if (value) {
                                        // Boşlukları sil ve uppercase yap
                                        const formatted = value.replace(/\s/g, '').toUpperCase();
                                        setPlateNumber(formatted);
                                    } else {
                                        setPlateNumber('');
                                    }
                                }}
                                onKeyPress={handleKeyPress}
                                showClearButton={true}
                                width="100%"
                                height={30}
                                style={{
                                    flex: '1',
                                    minWidth: '150px',
                                    maxWidth: '250px'
                                }}
                            />
                            <button
                                onClick={() => fetchData(true)}
                                disabled={loading}
                                style={{
                                    padding: '5px 12px',
                                    fontSize: '12px',
                                    height: '30px',
                                    borderRadius: '2px',
                                    border: '1px solid #007bff',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    opacity: loading ? 0.6 : 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {loading ? <i className="fa fa-spinner fa-spin"></i> : 'Ara'}
                            </button>
                        </div>

                        {/* Grupaj Listesi - Şık Minimal Collapse */}
                        {loading ? (
                            <div className="text-center py-4">
                                <i className="fa fa-spinner fa-spin fa-2x text-primary"></i>
                            </div>
                        ) : dataSource.length === 0 ? (
                            <div className="text-center py-4">
                                <i className="fa fa-inbox fa-2x text-muted mb-2"></i>
                                <p className="text-muted mb-0" style={{ fontSize: '13px' }}>Grupaj bulunamadı</p>
                            </div>
                        ) : (() => {
                            // Pagination hesaplamaları
                            const totalPages = Math.ceil(dataSource.length / itemsPerPage);
                            const startIndex = (currentPage - 1) * itemsPerPage;
                            const endIndex = startIndex + itemsPerPage;
                            const currentData = dataSource.slice(startIndex, endIndex);

                            return (
                                <>
                                    <div className="grupaj-list">
                                        {currentData.map((item, index) => {
                                            const isEven = index % 2 === 0;
                                            const bgColor = isEven ? 'rgb(239 239 239)' : '#ffffff';
                                            const headerBgColor = openCollapses[item.grupajNo]
                                                ? (isEven ? '#f5f5f5' : '#e9ecef')
                                                : bgColor;

                                            return (
                                                <div
                                                    key={item.grupajNo}
                                                    className="mb-2"
                                                    style={{
                                                        border: '1px solid #e8e8e8',
                                                        borderRadius: '4px',
                                                        overflow: 'hidden',
                                                        backgroundColor: bgColor
                                                    }}
                                                >
                                                    {/* Header - Minimal */}
                                                    <div
                                                        className="d-flex justify-content-between align-items-center"
                                                        style={{
                                                            cursor: 'pointer',
                                                            padding: '8px 10px',
                                                            backgroundColor: headerBgColor,
                                                            borderBottom: openCollapses[item.grupajNo] ? '1px solid #e8e8e8' : 'none'
                                                        }}
                                                        onClick={() => toggleCollapse(item.grupajNo)}
                                                    >
                                                        <div className="d-flex align-items-center" style={{ flex: 1, minWidth: 0, gap: '8px' }}>
                                                            <i
                                                                className={`fa fa-chevron-${openCollapses[item.grupajNo] ? 'down' : 'right'}`}
                                                                style={{
                                                                    color: '#666',
                                                                    fontSize: '10px',
                                                                    width: '12px',
                                                                    flexShrink: 0
                                                                }}
                                                            ></i>
                                                            <span style={{
                                                                fontWeight: '600',
                                                                fontSize: '13px',
                                                                color: '#333'
                                                            }}>
                                                                {item.grupajNo}
                                                            </span>
                                                            <span style={{ fontSize: '10px', color: '#999' }}>
                                                                {item.aracSayisi || 0} araç
                                                            </span>
                                                            {item.kapiCikisSayisi > 0 && (
                                                                <span style={{
                                                                    fontSize: '9px',
                                                                    padding: '1px 4px',
                                                                    backgroundColor: '#e8f5e9',
                                                                    color: '#2e7d32',
                                                                    borderRadius: '2px'
                                                                }}>
                                                                    {item.kapiCikisSayisi} çıkış
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Detaylar */}
                                                    <Collapse isOpen={openCollapses[item.grupajNo]}>
                                                        <div style={{
                                                            padding: '8px',
                                                            backgroundColor: '#fff',
                                                            borderTop: '1px solid #e8e8e8'
                                                        }}>
                                                            {/* Özet Bilgiler - Minimal */}
                                                            <div style={{
                                                                display: 'flex',
                                                                gap: '2px',
                                                                marginBottom: '12px',
                                                                paddingBottom: '8px',
                                                                borderBottom: '1px solid #f0f0f0',
                                                                flexWrap: 'wrap',
                                                                fontSize: '11px',
                                                                color: '#666',
                                                                lineHeight: '1.5'
                                                            }}>
                                                                <span>
                                                                    <span style={{ color: '#999' }}>Şoför:</span> {item.sofor || '-'}
                                                                </span>
                                                                <span style={{ color: '#ddd' }}>•</span>
                                                                <span>
                                                                    <span style={{ color: '#999' }}>Plaka:</span> {item.plaka || '-'}
                                                                </span>
                                                                <span style={{ color: '#ddd' }}>•</span>
                                                                <span>
                                                                    <span style={{ color: '#999' }}>Rota:</span> {
                                                                        item.fromLocation && item.toLocation ? (
                                                                            <span>{item.fromLocation} → {item.toLocation}</span>
                                                                        ) : item.fromLocation ? (
                                                                            <span>{item.fromLocation}</span>
                                                                        ) : item.toLocation ? (
                                                                            <span>{item.toLocation}</span>
                                                                        ) : (
                                                                            <span>-</span>
                                                                        )
                                                                    }
                                                                </span>
                                                            </div>

                                                            {/* Şase Listesi */}
                                                            <div>
                                                                <div style={{
                                                                    fontSize: '11px',
                                                                    fontWeight: '600',
                                                                    color: '#666',
                                                                    marginBottom: '12px',
                                                                    textTransform: 'uppercase',
                                                                    letterSpacing: '0.5px',
                                                                    paddingBottom: '6px',
                                                                    borderBottom: '1px solid #f0f0f0'
                                                                }}>
                                                                    Şaseler ({item.vehicleDetails?.length || 0})
                                                                </div>
                                                                {item.vehicleDetails && item.vehicleDetails.length > 0 ? (
                                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                                        {item.vehicleDetails.map((vehicle, vIndex) => {
                                                                            const hasDoorExit = !!vehicle.doorExitDate;
                                                                            const hasDelivery = !!vehicle.deliveryDate;
                                                                            const isProcessing = processingChassis === vehicle.chassisNo;

                                                                            return (
                                                                                <div
                                                                                    key={vehicle.chassisNo}
                                                                                    style={{
                                                                                        border: '1px solid #e0e0e0',
                                                                                        borderRadius: '6px',
                                                                                        padding: '12px',
                                                                                        backgroundColor: hasDelivery ? '#f0f9ff' : hasDoorExit ? '#f0fff4' : '#ffffff',
                                                                                        display: 'flex',
                                                                                        flexDirection: 'column',
                                                                                        gap: '10px',
                                                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                                                                                    }}
                                                                                >
                                                                                    {/* Şase Numarası */}
                                                                                    <div>
                                                                                        <div style={{
                                                                                            fontSize: '13px',
                                                                                            color: '#333',
                                                                                            fontWeight: '600',
                                                                                            wordBreak: 'break-all',
                                                                                            fontFamily: 'monospace',
                                                                                            letterSpacing: '0.5px'
                                                                                        }}>
                                                                                            {vehicle.chassisNo}
                                                                                        </div>
                                                                                        {(hasDoorExit || hasDelivery) && (
                                                                                            <div style={{
                                                                                                fontSize: '10px',
                                                                                                color: '#666',
                                                                                                display: 'flex',
                                                                                                gap: '5px',
                                                                                                flexWrap: 'wrap',
                                                                                                marginTop: '6px',
                                                                                                paddingTop: '6px',
                                                                                                borderTop: '1px solid #f0f0f0'
                                                                                            }}>
                                                                                                {hasDoorExit && (
                                                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                                                        <i className="fa fa-check-circle" style={{ color: '#28a745', fontSize: '10px' }}></i>
                                                                                                        <span style={{ color: '#28a745', fontWeight: '500' }}>Kapı Çıkış:</span>
                                                                                                        <span>{moment(vehicle.doorExitDate).format('DD.MM.YYYY HH:mm')}</span>
                                                                                                    </span>
                                                                                                )}
                                                                                                {hasDelivery && (
                                                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                                                        <i className="fa fa-check-circle" style={{ color: '#17a2b8', fontSize: '10px' }}></i>
                                                                                                        <span style={{ color: '#17a2b8', fontWeight: '500' }}>Teslim:</span>
                                                                                                        <span>{moment(vehicle.deliveryDate).format('DD.MM.YYYY')}</span>
                                                                                                    </span>
                                                                                                )}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>

                                                                                    {/* Butonlar */}
                                                                                    <div style={{ display: 'flex', gap: '6px', width: '100%' }}>
                                                                                        <Button
                                                                                            color={hasDoorExit ? "success" : "primary"}
                                                                                            size="sm"
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                if (!hasDoorExit) {
                                                                                                    if (window.confirm('Kapı çıkış işlemini yapmak istediğinize emin misiniz?')) {
                                                                                                        handleDoorExit(item.grupajNo, vehicle.chassisNo);
                                                                                                    }
                                                                                                }
                                                                                            }}
                                                                                            disabled={hasDoorExit || isProcessing}
                                                                                            style={{
                                                                                                fontSize: '11px',
                                                                                                padding: '6px 6px',
                                                                                                borderRadius: '3px',
                                                                                                flex: 1,
                                                                                                height: '32px'
                                                                                            }}
                                                                                        >
                                                                                            {isProcessing ? (
                                                                                                <>
                                                                                                    <i className="fa fa-spinner fa-spin mr-1"></i>
                                                                                                    İşleniyor
                                                                                                </>
                                                                                            ) : hasDoorExit ? (
                                                                                                <>
                                                                                                    <i className="fa fa-check mr-1"></i>
                                                                                                    Kapı Çıkış Yapıldı
                                                                                                </>
                                                                                            ) : (
                                                                                                <>
                                                                                                    <i className="fa fa-sign-out mr-1"></i>
                                                                                                    Kapı Çıkış
                                                                                                </>
                                                                                            )}
                                                                                        </Button>
                                                                                        <Button
                                                                                            color={hasDelivery ? "success" : "warning"}
                                                                                            size="sm"
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                if (!hasDelivery && hasDoorExit) {
                                                                                                    // İlk teslim kontrolü: Bu grupajda hiç teslim edilmiş şase var mı?
                                                                                                    const hasAnyDelivery = item.vehicleDetails.some(v => !!v.deliveryDate);
                                                                                                    setIsFirstDelivery(!hasAnyDelivery);

                                                                                                    setSelectedChassis(vehicle.chassisNo);
                                                                                                    setSelectedGroupageNo(item.grupajNo);
                                                                                                    setDeliveryImage(null);
                                                                                                    setDeliveryImageBase64(null);
                                                                                                    if (fileInputRef.current) fileInputRef.current.value = '';
                                                                                                    setDeliveryModalOpen(true);
                                                                                                }
                                                                                            }}
                                                                                            disabled={hasDelivery || !hasDoorExit || isProcessing}
                                                                                            style={{
                                                                                                fontSize: '11px',
                                                                                                padding: '6px 6px',
                                                                                                borderRadius: '3px',
                                                                                                flex: 1,
                                                                                                height: '32px'
                                                                                            }}
                                                                                        >
                                                                                            {isProcessing ? (
                                                                                                <>
                                                                                                    <i className="fa fa-spinner fa-spin mr-1"></i>
                                                                                                    İşleniyor
                                                                                                </>
                                                                                            ) : hasDelivery ? (
                                                                                                <>
                                                                                                    <i className="fa fa-check mr-1"></i>
                                                                                                    Teslim Edildi
                                                                                                </>
                                                                                            ) : (
                                                                                                <>
                                                                                                    <i className="fa fa-truck mr-1"></i>
                                                                                                    Teslim Ettim
                                                                                                </>
                                                                                            )}
                                                                                        </Button>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                ) : (
                                                                    <div style={{ fontSize: '11px', color: '#999', fontStyle: 'italic', padding: '8px', textAlign: 'center' }}>
                                                                        Şase bilgisi bulunamadı
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </Collapse>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    {/* Pagination - Minimal */}
                                    {totalPages > 1 && (
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            gap: '6px',
                                            marginTop: '12px',
                                            padding: '8px',
                                            flexWrap: 'wrap'
                                        }}>
                                            <button
                                                onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                                                disabled={currentPage === 1}
                                                style={{
                                                    padding: '4px 8px',
                                                    fontSize: '11px',
                                                    border: '1px solid #ddd',
                                                    backgroundColor: currentPage === 1 ? '#f5f5f5' : '#fff',
                                                    color: currentPage === 1 ? '#999' : '#333',
                                                    borderRadius: '3px',
                                                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                                    height: '28px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '4px'
                                                }}
                                            >
                                                <i className="fa fa-chevron-left"></i>
                                            </button>

                                            <span style={{ fontSize: '11px', color: '#666', padding: '0 4px' }}>
                                                {currentPage} / {totalPages}
                                            </span>

                                            <button
                                                onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                                                disabled={currentPage === totalPages}
                                                style={{
                                                    padding: '4px 8px',
                                                    fontSize: '11px',
                                                    border: '1px solid #ddd',
                                                    backgroundColor: currentPage === totalPages ? '#f5f5f5' : '#fff',
                                                    color: currentPage === totalPages ? '#999' : '#333',
                                                    borderRadius: '3px',
                                                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                                    height: '28px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '4px'
                                                }}
                                            >
                                                <i className="fa fa-chevron-right"></i>
                                            </button>
                                        </div>
                                    )}
                                </>
                            );
                        })()}
                    </CardBody>
                </Card>
            </div>

            {/* Teslim Modal */}
            <Modal isOpen={deliveryModalOpen} toggle={() => {
                setDeliveryModalOpen(false);
                setSelectedChassis(null);
                setSelectedGroupageNo(null);
                setDeliveryImage(null);
                setDeliveryImageBase64(null);
                setIsFirstDelivery(false);
                if (fileInputRef.current) fileInputRef.current.value = '';
            }} size="md">
                <ModalHeader toggle={() => {
                    setDeliveryModalOpen(false);
                    setSelectedChassis(null);
                    setSelectedGroupageNo(null);
                    setDeliveryImage(null);
                    setDeliveryImageBase64(null);
                    setIsFirstDelivery(false);
                    if (fileInputRef.current) fileInputRef.current.value = '';
                }}>
                    <div>
                        <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '2px' }}>
                            Teslim İşlemi
                        </div>
                        <div style={{ fontSize: '12px', color: '#666', fontWeight: 'normal' }}>
                            Grupaj No: {selectedGroupageNo}
                        </div>
                        <div style={{ fontSize: '12px', color: '#666', fontWeight: 'normal' }}>
                            Şase No: {selectedChassis}
                        </div>
                        <div style={{ fontSize: '11px', color: '#dc3545', fontWeight: '500', marginTop: '4px' }}>
                            <i className="fa fa-exclamation-circle mr-1"></i>
                            Teslim için resim yüklemek zorunludur
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody style={{ padding: '20px' }}>
                    <FormGroup>
                        <Label for="deliveryImage" style={{ fontWeight: "500", fontSize: '13px', marginBottom: '6px', display: 'block' }}>
                            İrsaliye Resmi <span className="text-danger">*</span>
                        </Label>
                        <div style={{
                            border: '2px dashed #ddd',
                            borderRadius: '4px',
                            padding: '15px',
                            textAlign: 'center',
                            backgroundColor: '#fafafa',
                            marginBottom: '8px'
                        }}>
                            <Input
                                id="deliveryImage"
                                type="file"
                                accept="image/*"
                                onChange={handleImageSelect}
                                ref={fileInputRef}
                                capture="environment"
                                style={{
                                    fontSize: '13px',
                                    display: 'none'
                                }}
                            />
                            <label
                                htmlFor="deliveryImage"
                                style={{
                                    cursor: 'pointer',
                                    display: 'block',
                                    padding: '10px'
                                }}
                            >
                                <i className="fa fa-camera fa-2x mb-2" style={{ color: '#6c757d' }}></i>
                                <div style={{ fontSize: '13px', color: '#666', marginBottom: '4px' }}>
                                    İrsaliye resmini çekip yükleyiniz
                                </div>
                                <div style={{ fontSize: '11px', color: '#999' }}>
                                    Maksimum dosya boyutu: 5MB
                                </div>
                            </label>
                        </div>
                        {deliveryImage && (
                            <div className="mt-2" style={{
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                padding: '8px',
                                backgroundColor: '#fff'
                            }}>
                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '6px' }}>
                                    <i className="fa fa-check-circle text-success mr-1"></i>
                                    Yüklenen resim:
                                </div>
                                <img
                                    src={deliveryImageBase64}
                                    alt="İrsaliye resmi"
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '300px',
                                        borderRadius: '4px',
                                        border: '1px solid #e0e0e0',
                                        display: 'block',
                                        margin: '0 auto'
                                    }}
                                />
                                <div style={{ fontSize: '11px', color: '#666', marginTop: '6px', textAlign: 'center' }}>
                                    {deliveryImage.name} ({(deliveryImage.size / 1024 / 1024).toFixed(2)} MB)
                                </div>
                            </div>
                        )}
                    </FormGroup>
                </ModalBody>
                <ModalFooter style={{ padding: '12px 20px', borderTop: '1px solid #e9ecef' }}>
                    <Button
                        color="secondary"
                        size="sm"
                        onClick={() => {
                            setDeliveryModalOpen(false);
                            setSelectedChassis(null);
                            setSelectedGroupageNo(null);
                            setDeliveryImage(null);
                            setDeliveryImageBase64(null);
                            setIsFirstDelivery(false);
                            if (fileInputRef.current) fileInputRef.current.value = '';
                        }}
                        style={{ padding: '6px 16px' }}
                    >
                        İptal
                    </Button>
                    <Button
                        color="primary"
                        size="sm"
                        onClick={() => {
                            if (window.confirm('Teslim işlemini yapmak istediğinize emin misiniz?')) {
                                handleDelivery();
                            }
                        }}
                        disabled={!deliveryImageBase64 || processingChassis === selectedChassis}
                        style={{ padding: '6px 16px' }}
                    >
                        {processingChassis === selectedChassis ? (
                            <>
                                <i className="fa fa-spinner fa-spin mr-1"></i>
                                Kaydediliyor...
                            </>
                        ) : (
                            <>
                                <i className="fa fa-save mr-1"></i>
                                Kaydet
                            </>
                        )}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default PlakaIleGrupajSorgulama;
